export const userTimezone = (): string => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    } catch {
        return "UTC";
    }
};

export const timezoneOptions = (): string[] => {
    const supportedValuesOf = (Intl as unknown as {supportedValuesOf?: (key: "timeZone") => string[]}).supportedValuesOf;
    const supported = supportedValuesOf ? supportedValuesOf("timeZone") : [];
    return Array.from(new Set([userTimezone(), "UTC", ...supported]));
};
